angular.module('task-project')
    .component('taskProjectStatusLabel', {
        bindings: {
            status: '<',
            flag: '<'
        },
        template: `
            <span ng-if="$ctrl.status && $ctrl.flag === true" class="task-project-status-label {{$ctrl.status}}" title="{{ \'task-project.status.\'.concat($ctrl.status) | translate }}"><i class="flag fa fa-fw fa-font-awesome"></i></span>
            <span ng-if="$ctrl.status && !$ctrl.flag" class="label label-default task-project-status-label {{$ctrl.status}}">{{ \'task-project.status.\'.concat($ctrl.status) | translate }}</span>
        `
    })
